<template>
  <div>
    <div v-for="(customer, index) in customers" :key="customer.id" class="mb-60">

      <el-divider content-position="left" class="fs-16"><PortausLink :id="customer.id" :label="customerName(customer.name, customer.usualName)" path="/customers/" fs="fs-20"></PortausLink></el-divider>

      <el-table :data="[
        {name:'total_credit_emited', header:false, total:getTotalCrediByCustomer[index].creditEmited},
        {name:'total_credit_paid', header:false, total:getTotalCrediByCustomer[index].creditPaid},
        {name:'totalCreditLeft', header:true, total:getTotalCrediByCustomer[index].creditOutstanding}
      ]" style="width:100%" ref="summary" :cell-style="{padding:'4px'}" header-row-class-name="fs-12">
        <el-table-column  align="left" label="Sommaire">
          <template slot-scope="scope">
            <span class="fs-12" v-bind:class="{'secondary-text' : !scope.row.header, 'pl-30' : !scope.row.header}">{{$t('reports.CREDITS_DETAIL.headers.'+scope.row.name)}}</span>
          </template>
        </el-table-column>
        <el-table-column  align="right" >
          <template slot-scope="scope">
            <span class="fs-12" v-bind:class="{'secondary-text' : !scope.row.header}">{{scope.row.total}} $</span>
          </template>
        </el-table-column>
      </el-table>
      <CreditsSummary v-if="filters.detailed==false" :credits="customer.credits"></CreditsSummary>
      <div v-else v-for="credit in customer.credits" :key="credit.id" class="m-60 p-40 border-left" >
        <el-table :data="credit.lines" style="100%" ref="summary" :cell-style="{padding:'4px'}" stripe header-row-class-name="fs-12">
          <el-table-column  align="left" label="Description" prop="product.name" v-if="productCreditedType(credit)">
            <template slot-scope="scope">
              <span class="fs-12 secondary-text">
                <span>{{scope.row.product.name}}</span>
                <span v-if="scope.row.product.provider!=null">, {{customerName(scope.row.product.provider.name,scope.row.product.provider.usualName)}}
                </span>
                <span class="fs-11 secondary-text"><br>{{scope.row.product.sku}}</span>
              </span>
              <span class="fs-11 secondary-text"><br>{{scope.row.description}}</span>
            </template>
          </el-table-column>
          <el-table-column  align="left" label="Type de crédit" prop="product.name">
            <template slot-scope="scope">
              <span class="fs-12 secondary-text">
                <span v-if="scope.row.type">{{scope.row.type.name}}</span>
                <span v-else>S.O.</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column  align="center" label="Prix">
            <template slot-scope="scope">
              <span class="fs-12 secondary-text">{{$n(scope.row.price,'currency',credit.currency.code)}}</span>
            </template>
          </el-table-column>
          <el-table-column  align="center" prop="qty" label="Quantité">
            <template slot-scope="scope">
              <span class="fs-12 secondary-text">{{scope.row.qty}}</span>
            </template>
          </el-table-column>
          <el-table-column  align="right" prop="sub_total" label="Sous total">
            <template slot-scope="scope">
              <span class="fs-12 secondary-text">{{$n(scope.row.subTotal,'currency',credit.currency.code)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <table style="width:100%;margin-top:20px;">
            <tr>
              <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">Sous-total : </td>
              <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(credit.subTotal,'currency',credit.currency.code)}}</td>
            </tr>
            <tr v-for="(tax, index) in credit.taxes" :key="index">
              <td class="fs-12 secondary-text" style="text-align:right;">{{tax.name || tax.label}} ({{tax.number || tax.taxNumber}}) : </td>
              <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',credit.currency.code)}}</td>
            </tr>
            <tr>
              <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">Crédit émis : </td>
              <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(credit.total,'currency',credit.currency.code)}}</td>
            </tr>
            <tr v-if="credit.balance.paid > 0">
              <td class="fs-12 secondary-text" style="text-align:right;">Crédit utilisé : </td>
              <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(credit.balance.paid,'currency',credit.currency.code)}}</td>
            </tr>
            <tr>
              <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">Crédit restant : </td>
              <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(credit.balance.outstanding,'currency',credit.currency.code)}}</td>
            </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import CreditsSummary from '@/components/creditNote/credits-summary.vue'
export default {
  name : "creditsDetailCustomerView",
  props: {
    customers : Array,
    filters : Object
	},
  data() {
    return {

    };
  },
  components : {
    PortausLink,
    CreditsSummary
  },
  methods : {

    productCreditedType(credit){
      return credit.type ==='PRODUCTS'
    },
    customerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    }
  },
  computed : {
    getTotalCrediByCustomer(){
      let totalByCustomer = [];

      _.forEach(this.customers, (customer) => {
        let creditEmited = 0;
        let creditPaid = 0;
        let creditOutstanding = 0;
        _.forEach(customer.credits, (credit) => {
          creditEmited += credit.balance.total;
          creditPaid += credit.balance.paid;
          creditOutstanding += credit.balance.outstanding;
        })
        totalByCustomer.push({
          creditEmited  : Math.round(creditEmited*100)/100,
          creditPaid: Math.round(creditPaid*100)/100,
          creditOutstanding:Math.round(creditOutstanding*100)/100})
      })

      return totalByCustomer;
    },
  }
}
</script>
<style lang="scss" scoped>


</style>
